export const COLORS = {
  orange: '#D97752',
  white: '#FFFFFF',
  brown: '#886B58',
  grey: '#2D2D2D',
  blurColor: '#EAEAEA',
  lightGray: '#F8F8F8',
  darkOrange: '#BC5832',
  black: '#000000',
  green: '#B1CB79',
};

const breakpoints = {
  laptopBP: '1440px',
  mobileBP: '480px',
};

export const BREAKPOINTS = {
  laptop: `(max-width: ${breakpoints.laptopBP})`,
  mobile: `(max-width: ${breakpoints.mobileBP})`,
};
